const QUERY = '.site-preloader';
const DURATION = null;

/**
 * This feature is used to set preloader behavior
 * 
 * @class Preloader
 * @param {string} [query]
 * @param {number} [duration]
 * @param {function} [onload]
 */

export default class Preloader {
    constructor (query = QUERY, duration = DURATION, onload = () => {}) {    
        const el = document.querySelector(query) || document.querySelector(QUERY);
        if (!el) throw new Error('Preloader not found');

        this.el = el;
        this.duration = duration;
        this.onload = onload;

        return this.init();
    }

    init () {
        return new Promise((resolve) => {
            let progress = 0;
            const percentEl = this.el.querySelector('.site-preloader__content');
            const step = this.duration / 100;

            const interval = setInterval(() => {
                progress++;
                percentEl.textContent = `${progress}%`;

                if (progress >= 100) {
                    clearInterval(interval);

                    this.el.classList.add('hidden');
                    this.onload();
                    resolve();
                }
            }, step);
        });
    }
}

/**
 * Usage example
 * 
 * import Preloader from 'components/preloader';
 * 
 * new Preloader('.site-preloader', null, () => {
 *  console.log('preloader loaded');
 * });
 * 
 * OR
 * 
 * new Preloader().then(() => console.log('preloader loaded'));
 * 
 */
